import { cx } from '@/lib/cx'
import { useErrorMessage } from '@/lib/i18n/errors'

/** Form-level failure banner (a request that failed as a whole); renders nothing when clear. */
export function FormError({ error, className }: { error: unknown; className?: string }) {
  const errorMessage = useErrorMessage()
  if (error == null || error === false) return null
  return (
    <p
      role="alert"
      className={cx('border-danger/40 text-danger bg-danger-soft rounded-lg border px-3 py-2 text-sm', className)}
    >
      {errorMessage(error)}
    </p>
  )
}
